export function mapImported (available, imported) {
  return available?.map(item =>
    Object.assign({}, item, {
      imported: imported?.findIndex(inner => inner.id === item.id) > -1,
    })
  )
}

export const getDefaultValues = Form =>
  Object.keys(Form).reduce((prev, curr) => {
    return { ...prev, [curr]: Form?.[curr].defaultValue }
  }, {})

export const modelDefaultValues = (Form, newModel) => {
  const defaultValues = getDefaultValues(Form);

  // Loop through the keys in newModel and update with default values if they are null or undefined
  for (const key in newModel) {
    if (newModel[key] === null || newModel[key] === undefined) {
      newModel[key] = defaultValues[key];
    }
  }

  return { ...defaultValues, ...newModel };
};
